import React, { useEffect, useState } from 'react';

const WhatsAppButton = () => {
  const [telefono, setTelefono] = useState("");

  useEffect(() => {
    fetch(`/data/generales.json?v=${Date.now()}`)
      .then(res => res.json())
      .then(data => {
        // Limpiar el teléfono de caracteres no numéricos
        const telefonoLimpio = data.contacto.telefono.replace(/[^\d]/g, "");
        setTelefono(telefonoLimpio);
      })
      .catch(err => console.error("Error cargando teléfono:", err));
  }, []);

  if (!telefono) return null;

  return (
    <a
      href={`https://wa.me/${telefono}?text=Necesito%20informaci%C3%B3n`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Enviar WhatsApp"
      style={{
        position: 'fixed',
        right: '24px',
        bottom: '24px',
        zIndex: 1000,
        background: '#25D366',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        transition: 'all 0.3s ease',
        textDecoration: 'none'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
      }}
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 32 32" 
        width="36" 
        height="36"
      >
        <path 
          fill="white" 
          d="M16 0C7.163 0 0 7.163 0 16c0 2.825.738 5.482 2.031 7.788L0 32l8.398-2.003A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.455c-2.514 0-4.883-.693-6.903-1.897l-.495-.295-5.135 1.223 1.262-4.613-.324-.514A13.387 13.387 0 0 1 2.545 16c0-7.424 6.031-13.455 13.455-13.455S29.455 8.576 29.455 16 23.424 29.455 16 29.455zm7.379-10.059c-.404-.202-2.391-1.179-2.762-1.314-.37-.134-.64-.202-.909.202-.269.404-1.043 1.314-1.279 1.583-.235.269-.471.303-.875.101-.404-.202-1.706-.629-3.249-2.005-1.2-1.071-2.011-2.394-2.246-2.798-.235-.404-.025-.622.177-.823.182-.181.404-.471.606-.707.202-.235.269-.404.404-.673.134-.269.067-.505-.034-.707-.101-.202-.909-2.191-1.246-3-.328-.788-.661-.681-.909-.694-.235-.012-.505-.015-.774-.015s-.707.101-1.077.505c-.37.404-1.414 1.381-1.414 3.37s1.448 3.908 1.65 4.177c.202.269 2.85 4.351 6.905 6.098.964.416 1.717.664 2.303.85.967.307 1.847.264 2.542.16.775-.116 2.391-.978 2.728-1.922.337-.944.337-1.753.235-1.922-.101-.169-.37-.269-.774-.471z"
        />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
